import { createEvent, restore, sample } from 'effector'
import { AddWinnersRequest } from './types'
import { fx } from '../../../../../libs'
import { RequestError } from '../../../../../shared/errorResponse'

export const addWinnersSubmit = createEvent<AddWinnersRequest>()

export const setError = createEvent<RequestError>()

export const setIsAddWinnersSuccess = createEvent<boolean>()

export const $isAddWinnersSuccess = restore(setIsAddWinnersSuccess, false)

export const $error = restore(setError, {
  message: '',
  code: 0,
})

export const addWinners = fx<AddWinnersRequest, void>({
  method: 'POST',
  url: `/promo/new_year_2026/winner/bulk`,
})

sample({
  // @ts-ignore
  clock: addWinnersSubmit,
  fn: ({ prizeType, tickets, userID }) => {
    let body: AddWinnersRequest = {
      prizeType,
      tickets,
    }

    if (userID) {
      body = {
        ...body,
        userID: userID,
      }
    }
    return {
      url: `/promo/new_year_2026/winner/bulk`,
      body: body,
    }
  },
  target: addWinners,
})

sample({
  clock: addWinners.failData,
  fn: (failData) => {
    return { message: failData.body.message, code: failData.status }
  },
  target: [setError],
})

sample({
  clock: addWinners.doneData,
  fn: () => {
    return true
  },
  target: setIsAddWinnersSuccess,
})
